<template>
  <div>
    <div class="bg-primary-light p-4 mb-4">
      <form @submit.prevent>
        <div class="mb-3">
          <label for="autoComplete" class="fw-bold h6">Keyword Search</label>
          <input id="autoComplete" class="w-100" type="text" :disabled="loading" v-model="keyword" />
        </div>
        <div class="d-md-flex gap-4">
          <div class="w-20">
            <h6 class="mb-2">Type</h6>
            <ul class="list-unstyled">
              <li v-for="(type, index) in library_types" :key="index" class="fs-8 text-dark"><input type="checkbox" :id="'type-'+type.id" :value="type.id" v-model="filteringTypes" :disabled="loading" /> <label :for="'type-'+type.id" v-html="type.name"></label></li>
            </ul>
          </div>

          <div class="w-80">
            <h6 class="mb-2">Category</h6>
            <div class="d-md-flex gap-4">
              <div v-for="cat in library_category" class="w-lg-33">
                <ul class="list-unstyled">
                  <li v-for="(c, index) in cat" :key="index" class="fs-8 text-dark"><input type="checkbox" :id="'category-'+c.id" :value="c.id" v-model="filteringCategories" :disabled="loading" /> <label :for="'category-'+c.id" v-html="c.name"></label></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <h6 class="mb-2">Results</h6>

          <div class="spinner-wrapper" v-if="loading">
            <div class="spinner-border d-block" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <p class="fs-1 meta-total text-dark" v-else>{{ total }}</p>

          <button class="btn btn-red btn-sm mb-3 me-1" @click="apply" :disabled="loading">Apply</button>
          <button class="btn btn-light btn-sm mb-3" @click="reset" :disabled="loading">Reset</button>
        </div>
      </form>
    </div>

    <div class="row" v-if="loading">
      <div class="col-md-6 col-lg-4" v-for="i in 9">
        <div class="bg-light mt-4 p-4 mb-4">
          <h5 class="d-block skeleton-loader skeleton-h5 bg-gray-400 w-50"></h5>
          <div class="d-block skeleton-loader skelton-description mb-3 bg-gray-400 w-100"></div>
        </div>
      </div> 
    </div>
    
    <div class="row">
      <div class="mb-4 col-md-6 col-lg-4" v-for="(entry, index) in entries.slice((currentPage * 9) - 9, currentPage * 9)" v-if="loading == false && entries.length > 0" :key="index">
        <div class="bg-light h-100 p-4">
            <div class="" v-if="entry.fimg_url"><img :src="entry.fimg_url" class="mt-3 mt-md-0 d-block w-100 h-auto mb-3" /></div>
            <div class="d-flex align-items-center mb-3" v-if="entry.resource_type" @click="filterByResourceInList(entry.resource_type[0].term_id)">
                <span class="fa-stack resource-icon d-block ms-n1">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-quote-right fa-stack-1x fa-inverse" v-if="entry.resource_type[0].slug === 'guide'"></i>
                  <i class="fas fa-file fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'brief'"></i>
                  <i class="fas fa-file-alt fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'case-study' || entry.resource_type[0].slug === 'web-post'"></i>
                  <i class="fas fa-video fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'video'"></i>
                  <i class="fas fa-book fa-stack-1x fa-inverse" v-if="entry.resource_type[0].slug === 'report'"></i>
                  <i class="fas fa-file-powerpoint fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'slide-deck'"></i>
                  <i class="fas fa-user fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'webinar'"></i>
                  <i class="fas fa-toolbox fa-stack-1x fa-inverse" v-else-if="entry.resource_type[0].slug === 'tool'"></i>
                </span>
                <p class="fw-bold fs-8 mb-0">{{ entry.resource_type[0].name }}</p>
              </div>

              <h5 v-if="entry.acf.type_of_link === 'internal'">
                <a :href="'/resource_library/'+entry.post_name" class="text-primary-medium border-0" v-html="entry.title.rendered"></a>
              </h5>
              <h5 v-else>
                <a :href="entry.acf.link" class="text-primary-medium border-0" v-html="entry.title.rendered"></a>
              </h5>
        </div>
      </div>
    </div>

    <div class="bg-light mb-4 p-4 d-inline-block" v-if="loading">
      <div class="d-block skelton-nav bg-gray-400"></div>
    </div>

    <nav aria-label="Page navigation" v-if="!loading && totalPages > 1">
      <ul class="pagination flex-wrap">
        <li class="page-item" :class="{ 'disabled' : !hasPreviousPage }"><span class="page-link" tabindex="-1" :aria-disabled=" !hasPreviousPage " @click="changePage('prev')">Previous</span></li>
        <li class="page-item" :class="{ 'active': index + 1 == currentPage }" v-for="(t, index) in totalPages" :key="index + 1" @click="changePage(index + 1)"><span class="page-link">{{ index + 1 }}</span></li>
        <li class="page-item" :class="{ 'disabled' : !hasNextPage }"><span class="page-link" :aria-disabled=" !hasNextPage " @click="changePage('next')">Next</span></li>
      </ul>
    </nav>

  </div>
</template>

<script>
import autoComplete from "@tarekraafat/autocomplete.js";

export default {
  data() {
    return {
      autoCompleteJS: null,
      cat: [],
      currentPage: 1,
      displayedEntries: [],
      entries: [],
      filteringTypes: [],
      filteringCategories: [],
      hasPreviousPage: false,
      hasNextPage: false,
      initialLoad: true,
      keyword: "",
      library_category: [],
      library_types: [],
      loading: true,
      originalEntries: [],
      perPage: 9,
      siteURL: null,
      total: 0,
      totalPages: 0,
    }
  },
 mounted() {
    const vm = this
    const autoCompleteJS = new autoComplete({
        placeHolder: "Search",
        data: {
          src: {},
          keys: ["title"]
        },
        resultItem: {
            highlight: true,
        }
    });

    autoCompleteJS.input.addEventListener("selection", function (event) {
        const feedback = event.detail;
        autoCompleteJS.input.blur();
        const selection = feedback.selection.value[feedback.selection.key];
        //autoCompleteJS.input.value = selection;
        vm.keyword = selection;
      });

    this.autoCompleteJS = autoCompleteJS;

    this.siteURL = document.querySelector("[data-site-url]").dataset.siteUrl;
    
    this.loadEntries();
  },
  methods: {
    async apply() {
      await this.loadEntries();
    },
    changePage(type) {
      if(type == 'next') {
        this.currentPage = this.currentPage + 1

      } else if(type == 'prev') {
        this.currentPage = this.currentPage - 1

      } else {
        this.currentPage = type
      }

      if(this.currentPage > 1 && this.currentPage < this.totalPages) {
        this.hasNextPage = true
      } else {
        this.hasNextPage = false
      }

      if(this.currentPage <= 1) {
        this.hasPreviousPage = false
      } else {
        this.hasPreviousPage = true
      }
    },
   async loadEntries() {
      this.loading = true;
      let categories = this.filteringCategories.join(",");
      if(categories !== "") {
        categories = `library_category=${categories}`
      }
      let types = this.filteringTypes.join(",");

      if(types !== "") {
        types = `resource_type=${types}`
      }

      this.entries = await this.loadJSON(`resource_library?_fields=id,title,slug,content,date,acf,resource_type,excerpt,fimg_url,featured_media&search=${this.keyword}&${categories}&${types}`);
      this.library_types = await this.loadJSON('resource_type?_fields=id,name,slug,acf&orderby=name&order=asc');
      this.library_category = await this.loadJSON('library_category?_fields=id,name,slug,acf&orderby=name&order=asc');

      const catLength = Math.ceil(this.library_category.length/9)
      let i = 0;
      let groups = [];
      while(i < catLength) {
        groups.push(this.library_category.splice(0, 9));
        i++;
      }

      this.library_category = groups;

      // order this.entries by date, then sticky = true first
      this.entries.sort((a, b) => {
        if(a.acf.sticky && !b.acf.sticky) {
          return -1;
        } else if(!a.acf.sticky && b.acf.sticky) {
          return 1;
        } else {
          return new Date(b.date) - new Date(a.date);
        }
      });

      this.translate_resource_type_id(this.entries)

      let data = {}

      if(this.initialLoad) {
        this.originalEntries = this.entries;
        this.initialLoad = false;
        // loop this.entries and create arrary of key values where key is title and value is the title
        data = this.entries.map(entry => {
          return {
            "title": entry.title.rendered,
            "id": entry.id,
          }
        });
      } else {
        // loop this.entries and create arrary of key values where key is title and value is the title
        data = this.originalEntries.map(entry => {
          return {
            "title": entry.title.rendered,
            "id": entry.id,
          }
        });
      }

      this.autoCompleteJS.data.src = data;

      this.total = this.entries.length;
      this.loading = false;
    },
    async loadJSON(url) {
      const vm = this
      let jsoncurrentPage = 1;
      let totalPages = 0;
      let entries = [];
      let morePages = true;

      while(morePages) {
        let response = await fetch(`/wp-json/wp/v2/${url}&per_page=25&page=${jsoncurrentPage}`);
        totalPages = response.headers.get('x-wp-totalpages');

        const data = await response.json();
        entries = entries.concat(data);

        if(!totalPages || totalPages == jsoncurrentPage) {
          morePages = false;
        } else if(totalPages == 0) {
          morePages = false;
        } else {
          jsoncurrentPage = jsoncurrentPage + 1;
        }
      }

      return entries;
    },
    reset() {
      this.currentPage = 1
      this.keyword = ""
      this.filteringCategories = []
      this.filteringMeasures = []
      this.filteringTypes = []
      this.hasPreviousPage = false
      this.hasNextPage = true
      this.totalPages = 0
      this.loadEntries()
    },
    translate_resource_type_id(entries) {
      // loop through entries and translate resource_type id to name
      entries.forEach(entry => {
        // find matching id in resource_type with entry.resource_type[0]
        let resource_type = this.library_types.find(resource_type => resource_type.id === entry.resource_type[0]);
        entry.resource_type[0] = resource_type;
        
      });
      this.entries = entries;
      this.displayedEntries = entries;
      
    },

  },
  watch: {
    displayedEntries: function() {
      this.totalPages = Math.ceil(this.displayedEntries.length / this.perPage);
      if(this.totalPages > 1) {
        this.hasNextPage = true;
      } else {
        this.hasNextPage = false;
      }
    },
  },
}
</script>

<style scoped>
  .skeleton-h5 {
    height: 30px;
  }
  .skelton-description {
    height: 170px;
  }
  .skelton-terms {
    height: 80px;
  }
  .skelton-nav {
    height: 40px;
    width: 430px;
  }
  .meta-total {
    font-family: "GT-America Light", sans-serif;
    font-weight: 100;
    line-height: 1;
  }
  .spinner-wrapper {
    align-items: center;
    display: flex;
    height: 92px;
  }
  .page-link {
    cursor: pointer;
  }
  .page-item.active .page-link {
    color: black;
  }
  @media(min-width: 768px) {
    .w-20 {
      width: 20%;
    }
    .w-lg-33 {
      width: 33%;
    }
    .w-80 {
      width: 80%;
    }
  }
</style>

<style>
  .autoComplete_wrapper {
    position: relative;
  }
  .autoComplete_wrapper ul {
    background-color: white;
    box-shadow: 0 3px 6px rgba(149, 157, 165, 0.15);
    list-style-type: none;
    margin: 0;
    padding: 1rem;
    position: absolute;
    top: 3rem;
    z-index: 9;
  }

  .autoComplete_wrapper ul li {
    cursor: pointer;
    margin: 0 0 1rem 0;
    padding: 0;
  }

  .autoComplete_wrapper ul li:last-of-type {
    margin: 0;
  }

  .autoComplete_wrapper mark {
    background-color: transparent;
    color: #457776;
    font-family: "GT-America-Bold", sans-serif;
    font-weight: 700;
    padding: 0;
    text-decoration: underline;
  }
  
</style>
